export class User {
  uId: string;
  name:string;
  companyName: string;
  message: string;
  isSuccess: boolean;
  role: Role;
  token: string;
  wrong_attempt: number;
  tokenexpiration?: any;
}
export class UserDetail {
  userid: number;
  name: string;
  companyName: string;
  emailId: string;
  address: string;
  userName: string;
  password: string;
  dateTime: string;
  status: string;
  wrong_attempt: string;
  lockdatetime: string;
  uid: string;
  rdate: Date;
  requestStatus:RequestStatus 
}

export enum Role{
  Admin=1,
  Client
}
export enum RequestStatus
{
    Pending=1,
    Complete
}
